import {LogoHeader} from "../../parts/LogoHeader";

export const LoginHeader = () => (
    <>
        <LogoHeader
            title={'Welcome to Arbito'}
            text={'Please enter your email or phone number to login'}
            />
    </>
)